export const CACHE_DURATION = 30
export const DESKTOP_WIDTH = 1024
export const DROPDOWN_PADDING = 56
export const EXPIRES_AT = 'expires_at'
export const LOGGED_IN = 'logged_in'
export const LOGGED_IN_RESPONSE = 'logged_in_response'
export const LOGGED_OUT_RESPONSE = 'logged_out_response'
